// time must have format '00:00:00,000'
export const getTimeFromTimestampStr = (time: string) => {
  const hours = Number(time.slice(0, 2));
  const minutes = Number(time.slice(3, 5));
  const seconds = Number(time.slice(6, 8));
  const ms = Number(time.slice(9, 12));

  return (hours * 60 * 60 + minutes * 60 + seconds) * 1000 + ms;
};
